import React, { forwardRef, Ref, useImperativeHandle, useRef } from "react"
import GTextField from "../libs/textfield/GTextField"
import { IconButton } from "@mui/material"
import { DeleteOutline } from "@mui/icons-material"
import PassUtils from "../data/PassUtils"

export interface IPropertyRowProps {
    passwordId:string
    index:number
    name?:string
    value?:string
    onUpdate?:(index:number,key:string,val:string) => void
    onDirty:() => void
    onDelete?:() => void
}
export interface IPropertyRowRefProps {
    name:string
    value:string
    focus:(type:"name"|"val") => void
}

export default forwardRef((props:IPropertyRowProps, ref:Ref<IPropertyRowRefProps>|null) => {
    const {passwordId,index} = props
    const name = useRef<HTMLInputElement>()
    const value = useRef<HTMLInputElement>()
    const onDelete = () => props.onDelete?.()
    const onChange = (e:any) => {
        if (!name.current || !value.current) return
        props.onUpdate?.(props.index, name.current.value, value.current.value)
    }
    const onDirty = () => props.onDirty()
    useImperativeHandle(ref, () => ({
        get name() { return name.current?.value || "" },
        get value() { return value.current?.value || "" },
        focus: (type:"name"|"val") => (type=="name" ? name : value).current?.focus()
    }))
    return <div className="property flex top gap-8">
        <GTextField className="flex1" defaultValue={props.name} inputRef={name} onChange={onDirty} onBlur={onChange} id={PassUtils.toInputId("name", passwordId, index)}/>
        <GTextField className="flex1" defaultValue={props.value} inputRef={value} onChange={onDirty} onBlur={onChange} id={PassUtils.toInputId("val", passwordId, index)}/>
        {props.onDelete ? <IconButton onClick={onDelete}><DeleteOutline/></IconButton> : <div/>}
    </div>
})